export const LOCALE = "en-US";
export const CURRENCY = "USD";
export const UTC_TIME_ZONE = "UTC";
export const INFINITY_TABLE = {
	ROW_HEIGHT: 19,
	COLUMN_HEADER_HEIGHT: 12,
	COLUMN_HEADER_COLLAPSED: 0,
};
